import { api } from './api';
import type { UserMemberType } from './usersApi';

/**
 * Communications identity/eligibility API (4C-1).
 *
 * The browser holds NO permission model of its own. Both calls here ask the server the same
 * questions it will ask itself when the action is attempted, so the picker offers exactly the
 * people the server would accept.
 */

export type ResolveRecipientOutcome =
  | { outcome: 'resolved'; user: { userId: string; displayName: string; memberType: UserMemberType } }
  | { outcome: 'invitable' }
  | { outcome: 'unavailable' };

/** POST /communications/resolve-recipient — one address, one safe outcome. */
export async function resolveRecipient(
  email: string,
  matterId?: string | null,
): Promise<ResolveRecipientOutcome> {
  const res = await api.post<ResolveRecipientOutcome>('/communications/resolve-recipient', {
    email,
    ...(matterId ? { matterId } : {}),
  });
  return res.data;
}

export interface EligibleParticipant {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  memberType: UserMemberType;
}

/**
 * GET /communications/matters/:matterId/eligible-participants — the people who may legitimately
 * join a conversation about this matter, from the same engine that enforces it.
 */
export async function fetchEligibleParticipants(matterId: string): Promise<EligibleParticipant[]> {
  const res = await api.get<{ data: { users: EligibleParticipant[] } }>(
    `/communications/matters/${matterId}/eligible-participants`,
  );
  return res.data.data.users;
}
